module.exports = __webpack_public_path__ + "img/imgshuai4.c4f61118.png";